<template>
    <div class="titulo-section">
        <h2 class="titulo-text fuente-posm">
            Todos tus pedidos en una plataforma.
        </h2>
    </div>
</template>

<script>
export default {
    name: 'TituloPlataformaNew'
}
</script>

<style lang="css" scoped>
.titulo-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    background-color: #272727;
}

.titulo-text {
    color: var(--color-5);
    font-size: 80px;
    line-height: 1.1;
    max-width: 850px;
    text-align: center;
    margin: 0;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .titulo-text {
        font-size: 70px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .titulo-section {
        padding: 100px 20px 40px 20px;
    }

    .titulo-text {
        font-size: 30px;
    }
}
</style>
